import _InputAdornment from './InputAdornment';

import './style/index.js';

export * from './type';
export type { InputAdornmentProps } from './InputAdornment';

export const InputAdornment = _InputAdornment;

export default _InputAdornment;
